import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ComparisonCard({ comparison }) {
  return (
    <Link
      to={`/comparisons/${comparison.slug}`}
      className="group block bg-surface border border-neutral-200 rounded-xl overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300"
      data-testid={`comparison-card-${comparison.slug}`}
    >
      <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center bg-gradient-to-br from-indigo-50/60 via-surface to-neutral-50 px-4 sm:px-6 py-7 border-b border-neutral-200">
        <div className="text-right min-w-0">
          <p className="font-playfair text-lg sm:text-2xl text-neutral-900 break-words">{comparison.product_a}</p>
        </div>
        <span className="mx-3 sm:mx-6 inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-800 text-surface font-playfair italic text-sm">
          vs
        </span>
        <div className="text-left min-w-0">
          <p className="font-playfair text-lg sm:text-2xl text-neutral-900 break-words">{comparison.product_b}</p>
        </div>
      </div>
      <div className="p-6">
        <span className="eyebrow">{comparison.category}</span>
        <h3 className="font-playfair text-lg text-neutral-900 mt-3 mb-3 group-hover:text-indigo-900 transition-colors">
          {comparison.title}
        </h3>
        <p className="text-sm text-neutral-600 line-clamp-2 mb-4">{comparison.excerpt}</p>
        <span className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-indigo-800">
          Read comparison <ArrowRight size={13} />
        </span>
      </div>
    </Link>
  );
}
